<template>
  <div>
    <h6 class="text-left table-header">
      {{ header | i18n }}
    </h6>
    <Table
      :columns="columns"
      :rows="items"
      :pagination="false"
      tableName="reportLoginTable"
    />
  </div>
</template>

<script>
import Table from '../../common/table';

export default {
  name: 'LatestOrders',
  components: { Table },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    header: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      columns: [
        { field: 'email', title: this.$translate('email'), align: 'left', key: '1' },
        { field: 'username', title: this.$translate('name'), align: 'left', key: '2' },
        { field: 'lastLoggedInAt', title: this.$translate('Last login'), align: 'left', key: '3' }
      ]
    };
  }
};
</script>

<style lang="scss">
.table-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 300;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>
